import React, { useState } from 'react';
import api from '../../utils/api';
import '../../styles/registro.css';

function Registro() {
  const [form, setForm] = useState({
    nombre: '',
    apellidos: '',
    email: '',
    contraseña: '',
  });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.contraseña.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres');
      return;
    }

    api.post(`solicitudes/`, form, { withCredentials: true })
      .then(() => {
        setMessage('Solicitud de registro enviada. Un administrador la revisará pronto.');
        setForm({ nombre: '', apellidos: '', email: '', contraseña: '' });
        setError('');
      })
      .catch(error => {
        setError(error.response?.data?.email || 'Error al enviar la solicitud');
        setMessage('');
      });
  };

  return (
    <div className="page">
      <h1>Registrarse</h1>
      {message && <p style={{ color: 'green' }}>{message}</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Nombre:</label>
          <input
            type="text"
            name="nombre"
            value={form.nombre}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Apellidos:</label>
          <input
            type="text"
            name="apellidos"
            value={form.apellidos}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Email (será tu usuario):</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Contraseña (mínimo 8 caracteres):</label>
          <input
            type="password"
            name="contraseña"
            value={form.contraseña}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit">Solicitar Registro</button>
      </form>
    </div>
  );
}

export default Registro;